"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-ten/sections/chooseusSection.tsx */

import { SmartImage } from "@/Components";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, Key, ReactNode } from "react";

type ChooseusSection6FadeInUpsItem = {
    key: Key | null | undefined;
    /** Detected variants: "/Templates/Doccure/img/icons/choose-05.svg" | "/Templates/Doccure/img/icons/choose-06.svg" | "/Templates/Doccure/img/icons/choose-07.svg" | "/Templates/Doccure/img/icons/choose-08.svg" */
    src: string;
    /** Detected variants: "Advanced Lab Technology" | "Experienced Embryologists" | "Personalized Care Protocols" | "Compassionate Emotional Support" */
    h30Text: ReactNode;
    /** Detected variants: "Our advanced lab technology and precise monitoring ensure safe and successful treatment outcomes." | "Experienced embryologists ensure your embryos receive the highest level of care." | "Our specialists create personalized treatment plans tailored to your unique needs and goals." | "We guide you with compassionate support from your first visit to pregnancy confirmation." */
    p0Text: ReactNode;
    /** Detected variants: "col-lg-6 d-flex wow fadeInUp" */
    className?: string;
    /** Detected variants: "0.2s" */
    dataWowDelay?: string;
    /** Detected variants: "1s" */
    dataWowDuration?: string;
    /** Detected variants: "choose-item-ten flex-fill" */
    div0ClassName?: string;
    /** Detected variants: "choose-icon" */
    div0ClassName2?: string;
    /** Detected variants: "icon" */
    alt?: string;
    /** Detected variants: "img-fluid" */
    imageWithBasePath0ClassName?: string;
    /** Detected variants: "custom-title" */
    h30ClassName?: string;
};
export type HomeTenChooseusSectionGeneratedProps = {
    divDiv0Div0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: ChooseusSection6FadeInUpsItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    divDiv0Div1H30H3Props?: Partial<ComponentProps<"h3">> | ((item: ChooseusSection6FadeInUpsItem) => Partial<ComponentProps<"h3">>);
    /** Default: "Why Choose Us" */
    sectionDiv0Div0Div0DivText?: ReactNode;
    /** Default: "Why Families Trust Us" */
    sectionDiv0Div0H20H2Text?: ReactNode;
    sectionDiv0Div0H20H2Visible?: boolean;
    sectionDiv0Div0H20H2Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0H20H2Props?: Partial<ComponentProps<"h2">>;
    sectionDiv0Div1ClassName?: string;
    /** Default: "bg" */
    sectionImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/choose-bg-6.png" */
    sectionImageWithBasePath0ImageSrc?: string;
    sectionImageWithBasePath0ImageVisible?: boolean;
    sectionImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "bg" */
    sectionImageWithBasePath1ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/choose-bg-7.png" */
    sectionImageWithBasePath1ImageSrc?: string;
    sectionImageWithBasePath1ImageVisible?: boolean;
    sectionImageWithBasePath1ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionImageWithBasePath1ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    chooseusSection6FadeInUps: ChooseusSection6FadeInUpsItem[];
    chooseusSection6FadeInUpsItemWrapper?: (item: ChooseusSection6FadeInUpsItem, content: ReactNode) => ReactNode;
    chooseusSection6FadeInUpsRenderer?: (defaultNode: ReactNode) => ReactNode;
    chooseusSection6FadeInUpsImageVisible?: boolean;
    chooseusSection6FadeInUpsImageRenderer?: (item: ChooseusSection6FadeInUpsItem, defaultNode: ReactNode) => ReactNode;
    chooseusSection6FadeInUpsH3Visible?: boolean;
    chooseusSection6FadeInUpsH3Renderer?: (item: ChooseusSection6FadeInUpsItem, defaultNode: ReactNode) => ReactNode;
    chooseusSection6FadeInUpsImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: ChooseusSection6FadeInUpsItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    chooseusSection6FadeInUpsH3Props?: Partial<ComponentProps<"h3">> | ((item: ChooseusSection6FadeInUpsItem) => Partial<ComponentProps<"h3">>);
};

const HomeTenChooseusSectionGenerated: FC<HomeTenChooseusSectionGeneratedProps> = ({
    sectionDiv0Div0Div0DivText = "Why Choose Us",
    sectionDiv0Div0H20H2Text = "Why Families Trust Us",
    sectionDiv0Div0H20H2Visible,
    sectionDiv0Div0H20H2Renderer,
    sectionDiv0Div0H20H2Props,
    sectionImageWithBasePath0ImageAlt = "bg",
    sectionImageWithBasePath0ImageSrc = "/Templates/Doccure/img/bg/choose-bg-6.png",
    sectionImageWithBasePath0ImageVisible,
    sectionImageWithBasePath0ImageRenderer,
    sectionImageWithBasePath0ImageProps,
    sectionImageWithBasePath1ImageAlt = "bg",
    sectionImageWithBasePath1ImageSrc = "/Templates/Doccure/img/bg/choose-bg-7.png",
    sectionImageWithBasePath1ImageVisible,
    sectionImageWithBasePath1ImageRenderer,
    sectionImageWithBasePath1ImageProps,
    divDiv0Div0ImageWithBasePath0ImageProps,
    divDiv0Div1H30H3Props,
    sectionDiv0Div1ClassName,
    chooseusSection6FadeInUps,
    chooseusSection6FadeInUpsItemWrapper,
    chooseusSection6FadeInUpsRenderer,
    chooseusSection6FadeInUpsImageVisible,
    chooseusSection6FadeInUpsImageRenderer,
    chooseusSection6FadeInUpsH3Visible,
    chooseusSection6FadeInUpsH3Renderer,
    chooseusSection6FadeInUpsImageProps,
    chooseusSection6FadeInUpsH3Props,
}) => {
    return (
        <section className="whychoose-section-ten section">
            <div className="container">
                <div className="section-header section-header-ten section-white text-center">
                    <div className="section-sub-title">
                        <span className="sec-circle" aria-hidden="true" />
                        {sectionDiv0Div0Div0DivText}
                    </div>
                    {renderNode(sectionDiv0Div0H20H2Visible, sectionDiv0Div0H20H2Renderer, (
                        <h2 className="section-title" {...(sectionDiv0Div0H20H2Props ?? {})}>{sectionDiv0Div0H20H2Text}</h2>
                    ))}
                </div>
                <div className={sectionDiv0Div1ClassName ?? "row g-4"}>
                    {renderCollectionNode(
                        chooseusSection6FadeInUps,
                        (item: ChooseusSection6FadeInUpsItem) => (
                            <div className={item.className ?? "col-lg-6 d-flex wow fadeInUp"} data-wow-delay={item.dataWowDelay ?? "0.2s"} data-wow-duration={item.dataWowDuration ?? "1s"} key={item.key}>
                                <div className={item.div0ClassName ?? "choose-item-ten flex-fill"}>
                                    <div className={item.div0ClassName2 ?? "choose-icon"}>
                                        {renderItemNode(chooseusSection6FadeInUpsImageVisible, chooseusSection6FadeInUpsImageRenderer, item, (
                                            <SmartImage src={item.src} alt={item.alt ?? "icon"} className={item.imageWithBasePath0ClassName ?? "img-fluid"} {...(typeof chooseusSection6FadeInUpsImageProps === "function" ? chooseusSection6FadeInUpsImageProps(item) : (chooseusSection6FadeInUpsImageProps ?? {}))} {...(typeof divDiv0Div0ImageWithBasePath0ImageProps === "function" ? divDiv0Div0ImageWithBasePath0ImageProps(item) : (divDiv0Div0ImageWithBasePath0ImageProps ?? {}))} />
                                        ))}
                                    </div>
                                    <div>
                                        {renderItemNode(chooseusSection6FadeInUpsH3Visible, chooseusSection6FadeInUpsH3Renderer, item, (
                                            <h3 className={item.h30ClassName ?? "custom-title"} {...(typeof chooseusSection6FadeInUpsH3Props === "function" ? chooseusSection6FadeInUpsH3Props(item) : (chooseusSection6FadeInUpsH3Props ?? {}))} {...(typeof divDiv0Div1H30H3Props === "function" ? divDiv0Div1H30H3Props(item) : (divDiv0Div1H30H3Props ?? {}))}>{item.h30Text}</h3>
                                        ))}
                                        <p>{item.p0Text}</p>
                                    </div>
                                </div>
                            </div>
                        ),
                        chooseusSection6FadeInUpsItemWrapper,
                        chooseusSection6FadeInUpsRenderer
                    )}
                </div>
            </div>
            {renderNode(sectionImageWithBasePath0ImageVisible, sectionImageWithBasePath0ImageRenderer, (
                <SmartImage src={sectionImageWithBasePath0ImageSrc} alt={sectionImageWithBasePath0ImageAlt} className="choose-bg-01" {...(sectionImageWithBasePath0ImageProps ?? {})} />
            ))}
            {renderNode(sectionImageWithBasePath1ImageVisible, sectionImageWithBasePath1ImageRenderer, (
                <SmartImage src={sectionImageWithBasePath1ImageSrc} alt={sectionImageWithBasePath1ImageAlt} className="choose-bg-02" {...(sectionImageWithBasePath1ImageProps ?? {})} />
            ))}
        </section>
    );
};

export default HomeTenChooseusSectionGenerated;
